import {
  pathogenicStrongColor,
  benignStrongColor,
  uncertainSignificanceColor,
} from "../../../../common/helpers/colors";

/*  For data sources: FATHMM, DEOGEN2, SIFT4G, PrimateAI, MetaSVM, M-CAP, MetaRNN
    Damaging will be displayed red
    Tolerated will be displayed green
*/
export const PREDICTIONS_GROUP_1 = {
  D: "Damaging",
  T: "Tolerated",
};

export const PREDICTION_GROUP_MIT_IMPACT = {
  Neutral: "Neutral",
  Pathogenic: "Pathogenic",
};
/*  For data sources: FATHMM-MKL, FATHMM-XF, PROVEAN
      Damaging will be displayed red
      Neutral will be displayed green
  */
export const PREDICTIONS_GROUP_2 = {
  D: "Damaging",
  N: "Neutral",
};

/*  For data source: MutationTaster
      Disease causing automatic will be displayed red
      Disease causing will be displayed red
      Polymorphism automatic will be displayed green
      Polymorphism will be displayed green
  */
export const PREDICTIONS_GROUP_3 = {
  A: "Disease causing automatic",
  D: "Disease causing",
  P: "Polymorphism automatic",
  N: "Polymorphism",
};

/*  For data source: LRT
      Deleterious will be displayed red
      Neutral will be displayed green
      Unknown will be displayed orange
  */
export const PREDICTIONS_GROUP_4 = {
  D: "Deleterious",
  N: "Neutral",
  U: "Unknown",
};

/*  For data source: Mutation assessor
      High will be displayed red
      Medium will be displayed red
      Low will be displayed green
      Neutral will be displayed orange
  */
export const PREDICTIONS_GROUP_6 = {
  H: "High",
  M: "Medium",
  L: "Low",
  N: "Neutral",
};

export const PREDICTION_PATHOGENIC_GROUP = [
  "Pathogenic",
  "Damaging",
  "Disease causing automatic",
  "Disease causing",
  "Deleterious",
  "Possibly damaging",
  "High",
  "Medium",
  "Dominant",
];

export const PREDICTION_UNCERTAIN_GROUP = ["Unknown", "Recessive", "Uncertain"];

export const PREDICTION_BENIGH_GROUP = [
  "Tolerated",
  "Tolerant",
  "Neutral",
  "Benign",
  "Polymorphism automatic",
  "Polymorphism",
  "Low",
];

export const PREDICTIONS_COLORS = {
  Pathogenic: pathogenicStrongColor,
  Damaging: pathogenicStrongColor,
  "Disease causing automatic": pathogenicStrongColor,
  "Disease causing": pathogenicStrongColor,
  Deleterious: pathogenicStrongColor,
  "Possibly damaging": pathogenicStrongColor,
  High: pathogenicStrongColor,
  Medium: pathogenicStrongColor,
  Dominant: pathogenicStrongColor,
  Tolerated: benignStrongColor,
  Tolerant: benignStrongColor,
  Neutral: benignStrongColor,
  Benign: benignStrongColor,
  "Polymorphism automatic": benignStrongColor,
  Polymorphism: benignStrongColor,
  Low: benignStrongColor,
  Unknown: uncertainSignificanceColor,
  Recessive: uncertainSignificanceColor,
  Uncertain: uncertainSignificanceColor,
};

export const DBNSFP_PREDICTIONS_FIELDS = [
  "mutationtaster_pred",
  "mutationtaster_score",
  "mutationtaster_converted_rankscore",
  "mutationassessor_pred",
  "mutationassessor_score",
  "mutationassessor_rankscore",
  "fathmm_pred",
  "fathmm_score",
  "fathmm_converted_rankscore",
  "fathmm_mkl_coding_pred",
  "fathmm_mkl_coding_score",
  "fathmm_mkl_coding_rankscore",
  "fathmm_xf_coding_pred",
  "fathmm_xf_coding_score",
  "fathmm_xf_coding_rankscore",
  "lrt_pred",
  "lrt_score",
  "lrt_converted_rankscore",
  "lrt_omega",
  "deogen2_pred",
  "deogen2_score",
  "deogen2_rankscore",
  "aloft_pred",
  "aloft_fraction_transcripts_affected",
  "aloft_prob_tolerant",
  "aloft_prob_recessive",
  "aloft_prob_dominant",
  "eigen_pred_coding",
  "eigen_raw_coding",
  "eigen_raw_coding_rankscore",
  "eigen_pc_phred_coding",
  "eigen_pc_raw_coding",
  "eigen_pc_raw_coding_rankscore",
  "sift_pred",
  "sift_score",
  "sift_converted_rankscore",
  "sift4g_pred",
  "sift4g_score",
  "sift4g_converted_rankscore",
  "provean_pred",
  "provean_score",
  "provean_converted_rankscore",
  "mvp_score",
  "mvp_rankscore",
  "revel_score",
  "revel_rankscore",
  "mutpred_score",
  "mutpred_rankscore",
  "primateai_pred",
  "primateai_score",
  "primateai_rankscore",
  "metasvm_pred",
  "metasvm_score",
  "metasvm_rankscore",
  "metalr_pred",
  "metalr_score",
  "metalr_rankscore",
  "metarnn_pred",
  "metarnn_score",
  "metarnn_rankscore",
  "m_cap_pred",
  "m_cap_score",
  "m_cap_rankscore",
  "dann_score",
  "dann_rankscore",
];
